module.exports = __webpack_public_path__ + "img/check-multiple.22b2661e.svg";